import { OnlineBookingGraphSettingsDto } from './../DTOs/Organisations/Models/OnlineBookingGraphSettingsDto';
import { Injectable, OnInit } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../environments/environment";

import { Observable, from } from "rxjs";
import { UpdateOrganisationCommand } from "../DTOs/Organisations/Commands/UpdateOrganisationCommand";
import { UpdateAftercareSettingsCommand } from "../DTOs/Organisations/Commands/UpdateAftercareSettingsCommand";
import { CreateAftercareSettingsCaseCommand } from "../DTOs/Organisations/Commands/CreateAftercareSettingsCaseCommand";
import { UpdateAftercareSettingsCaseCommand } from "../DTOs/Organisations/Commands/UpdateAftercareSettingsCaseCommand";

import { UpdateAftercareSettingsNotificationCommand } from "../DTOs/Organisations/Commands/UpdateAftercareSettingsNotificationCommand";
import { CreateAftercareSettingsNotificationCommand } from "../DTOs/Organisations/Commands/CreateAftercareSettingsNotificationCommand";
import { ProcedureProtocolDTO } from "../DTOs/Organisations/Models/ProcedureProtocolDTO";
import { of } from "rxjs";
import { OrganisationCenterDTO } from "../DTOs/Organisations/Models/OrganisationCenterDTO";
import { RoleDTO } from "../DTOs/Organisations/Models/RoleDTO";
import { CreateProcedureProtocolMappingCommand } from "../DTOs/Organisations/Commands/CreateProcedureProtocolMappingCommand";
import { UpdateProcedureProtocolMappingCommand } from "../DTOs/Organisations/Commands/UpdateProcedureProtocolMappingCommand";
import { CreateOrganisationMemberCommand } from "../DTOs/Organisations/Commands/CreateOrganisationMemberCommand";
import { UpdateOrganisationMemberCommand } from "../DTOs/Organisations/Commands/UpdateOrganisationMemberCommand";
import { CreateOrganisationMemberRoleCommand } from "../DTOs/Organisations/Commands/CreateOrganisationMemberRoleCommand";
import { UpdateOrganisationMemberRoleCommand } from "../DTOs/Organisations/Commands/UpdateOrganisationMemberRoleCommand";
import { UpdateOrganisationCenterCommand } from "../DTOs/Organisations/Commands/UpdateOrganisationCenterCommand";
import { CreateOrganisationCenterCommand } from "../DTOs/Organisations/Commands/CreateOrganisationCenterCommand";
import { UpdateOrganisationCenterAftercareSettingsCommand } from "../DTOs/Organisations/Commands/UpdateOrganisationCenterAftercareSettingsCommand";
import { CreateOrganisationCenterAftercareSettingsCommand } from "../DTOs/Organisations/Commands/CreateOrganisationCenterAftercareSettingsCommand";
import { CreateDoctorProviderMappingCommand } from "../DTOs/Organisations/Commands/CreateDoctorProviderMappingCommand";
import { UpdateDoctorProviderMappingCommand } from "../DTOs/Organisations/Commands/UpdateDoctorProviderMappingCommand";
import { CreateMemberAftercareSettingCommand } from "../DTOs/Organisations/Commands/CreateMemberAftercareSettingCommand";
import { UpdateMemberAftercareSettingCommand } from "../DTOs/Organisations/Commands/UpdateMemberAftercareSettingCommand";
import { CreateProcedureProtocolCommand } from "../DTOs/Organisations/Commands/CreateProcedureProtocolCommand";
import { UpdateProcedureProtocolCommand } from "../DTOs/Organisations/Commands/UpdateProcedureProtocolCommand";
import { CreateProcedureProtocolCommandMessage } from "../DTOs/Organisations/Commands/CreateProcedureProtocolCommandMessage";
import { UpdateProcedureProtocolCommandMessage } from "../DTOs/Organisations/Commands/UpdateProcedureProtocolCommandMessage";
import { UpdatePatientProcedureNotesCommand } from "../DTOs/PatientProcedures/Commands/UpdatePatientProcedureNotesCommand";
import { AppConfigService, AppConfig } from "../services/app-config.service";
import { UpdateOrgRoleCommand } from "../DTOs/Organisations/Commands/UpdateOrgRoleCommand";
import { CreateOrgRoleCommand } from "../DTOs/Organisations/Commands/CreateOrgRoleCommand";
import { AuthService } from "../auth/auth.service";
import { OrganizationLogoDto } from "../DTOs/Organisations/Models/OrganizationLogoDto";
import { TopLevelStatSetting } from "src/DTOs/Organisations/Models/TopLevelStatSetting";
import { VisitTypeDto } from "src/DTOs/Organisations/Models/VisitTypeDto";
import { UnresolvedAlertsSettingsDto } from "src/DTOs/Organisations/Models/UnresolvedAlertsSettingsDto";
import { AlertResolutionTimeSettingsDto } from "src/DTOs/Organisations/Models/AlertResolutionTimeSettingsDto";
import { GroupCategoryDTO } from "src/DTOs/Organisations/Models/GroupCategoryDTO";
import { publishReplay, map, refCount } from "rxjs/operators";
import { ResponseRateGraphSettingsDto } from "src/DTOs/Organisations/Models/ResponseRateGraphSettingsDto";
import { NpsGraphSettingsDto } from "src/DTOs/Organisations/Models/NpsGraphSettingsDto";
import { CustomGraphSettingsDto } from "src/DTOs/Organisations/Models/CustomGraphSettingsDto";
import { ProcedureProtocolMessageTemplateDTO } from "src/DTOs/Organisations/Models/ProcedureProtocolMessageTemplateDTO";
import { MultipleChoiceGraphSettingsDto } from "src/DTOs/Organisations/Models/MultipleChoiceGraphSettingsDto";
import { TrendingWordsSettingsDto } from "src/DTOs/Organisations/Models/TrendingWordsSettingsDto";
import { WizardViewModel } from "../app/components/wizards/dentally/wizard-view-model";
import { ProcedureProtocolMessageDTO } from "src/DTOs/Organisations/Models/ProcedureProtocolMessageDTO";
import { CommentsDisplaySettingsDto } from "src/DTOs/Organisations/Models/CommentsDisplaySettingsDto";
import { ResponseAnalysisSettingsDto } from "src/DTOs/Organisations/Models/ResponseAnalysisSettingsDto";
import { GoogleReviewsGraphSettingsDto } from "src/DTOs/Organisations/Models/GoogleReviewsGraphSettingsDto";
import { SuggestedReplyDto } from "src/DTOs/Organisations/Models/SuggestedReplyDto";
import { TopLevelStat } from "src/DTOs/Organisations/Models/TopLevelStat";
import { AutoReportsSettingsDto } from "src/DTOs/Organisations/Models/AutoReportsSettingsDto";
import { ExcludeQuestionAnswersDTO } from 'src/DTOs/PatientProcedures/Models/ExcludeQuestionAnswersDTO';
import { AiConfiguration } from "src/DTOs/Organisations/Models/AiConfiguration";

@Injectable()
export class OrgSettingsService implements OnInit {
  private org_api_url = "";
  private org_aftercare_api_url = "";
  private _isPassiveMode: Observable<boolean>;
  public appConfig: AppConfig = new AppConfig();

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService,
    private authService: AuthService
  ) {
    this.appConfig = this.appConfigService.getConfig();

    if (environment.debug_mode) {
      console.log(
        "OrgSettingsService, oc_api_url: " + this.appConfig.oc_api_url
      );
    }
  }

  ngOnInit(): void { }

  syncCurnex(): Observable<any> {
    let url: string =
      this.appConfig.oc_api_url + environment.oc_api_organizations_url + "synccurnex";

    return this.http.post<any>(url, {});
  }

  getAiConfiguration(orgId: string): Observable<AiConfiguration> {
    const url = `${this.appConfig.curnex_api_url}ai-features/${orgId}`;

    if (environment.debug_mode) {
      console.log("getAiConfiguration url: " + url);
    }

    return this.http.get<AiConfiguration>(url);
  }

  //-----------------------------------------------------------
  // delete - DeleteOrganizationLogo - begin
  //-----------------------------------------------------------
  DeleteOrganizationLogo(orgId: string): Observable<any> {
    

    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_organizations_url +
      orgId +
      "/logo";
    if (environment.debug_mode) {
      console.log("DeleteOrganizationLogo url: " + url);
    }

    return this.http.delete<any>(url);
  }
  //-----------------------------------------------------------
  // delete - DeleteOrganizationLogo - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // update - UpdateOrganizationLogo - begin
  //-----------------------------------------------------------
  UpdateOrganizationLogo(
    orgId: string,
    cmd: OrganizationLogoDto
  ): Observable<any> {
    

    if (environment.debug_mode) {
      console.log("UpdateOrganizationLogo: " + JSON.stringify(cmd));
    }

    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_organizations_url +
      orgId +
      "/logo";
    if (environment.debug_mode) {
      console.log("UpdateOrganizationLogo url: " + url);
    }

    return this.http.put<any>(url, JSON.stringify(cmd));
  }
  //-----------------------------------------------------------
  // update - UpdateOrganizationLogo - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // create - createProcedureProtocolMessageTemplate - begin
  //-----------------------------------------------------------
  createProcedureProtocolMessageTemplate(
    protocolId: string,
    messageId: string,
    template: ProcedureProtocolMessageTemplateDTO
  ): Observable<any> {
    

    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_procedure_protocols_url +
      protocolId +
      "/messages/" +
      messageId +
      "/templates/";

    if (environment.debug_mode) {
      console.log("createProcedureProtocolMessageTemplate url: " + url);
    }

    return this.http.post<any>(url, JSON.stringify(template));
  }
  //-----------------------------------------------------------
  // create - createProcedureProtocolMessageTemplate - end
  //-----------------------------------------------------------


  //-----------------------------------------------------------
  // update - updateProcedureProtocolMessageTemplate - begin
  //-----------------------------------------------------------
  updateProcedureProtocolMessageTemplate(
    protocolId: string,
    messageId: string,
    template: ProcedureProtocolMessageTemplateDTO
  ): Observable<any> {
    

    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_procedure_protocols_url +
      protocolId +
      "/messages/" +
      messageId +
      "/templates/" +
      template.Id;
    if (environment.debug_mode) {
      console.log("updateProcedureProtocolMessageTemplate url: " + url);
    }

    return this.http.put<any>(url, JSON.stringify(template));
  }
  //-----------------------------------------------------------
  // update - updateProcedureProtocolMessageTemplate - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // create - ProcedureProtocolMessage - begin
  //-----------------------------------------------------------
  createProcedureProtocolMessage(
    cmd: CreateProcedureProtocolCommandMessage
  ): Observable<any> {
    

    if (environment.debug_mode) {
      console.log("createProcedureProtocolMessage: " + JSON.stringify(cmd));
    }

    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_procedure_protocols_url +
      cmd.ProcedureProtocolId +
      "/Messages";

    if (environment.debug_mode) {
      console.log("createProcedureProtocolMessage url: " + url);
    }

    return this.http.post<any>(url, JSON.stringify(cmd));
  }
  //-----------------------------------------------------------
  // create - ProcedureProtocolMessage - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // update - ProcedureProtocolMessage - begin
  //-----------------------------------------------------------
  updateProcedureProtocolMessage(
    cmd: UpdateProcedureProtocolCommandMessage
  ): Observable<any> {
    

    if (environment.debug_mode) {
      console.log("updateProcedureProtocolMessage: " + JSON.stringify(cmd));
    }

    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_procedure_protocols_url +
      cmd.ProcedureProtocolId +
      "/Messages/" +
      cmd.Id;
    if (environment.debug_mode) {
      console.log("updateProcedureProtocolMessage url: " + url);
    }

    return this.http.put<any>(url, JSON.stringify(cmd));
  }
  //-----------------------------------------------------------
  // update - ProcedureProtocolMessage - end
  //-----------------------------------------------------------

  enableProcedureProtocolMessage(protocolId: string, messaggeId: string, enabled: { Enabled: boolean }): Observable<any> {
    
    const url =
      this.appConfig.oc_api_url +
      environment.oc_api_procedure_protocols_url +
      protocolId +
      "/Messages/" +
      messaggeId +
      "/enable";
    return this.http.put<any>(url, JSON.stringify(enabled));
  }

  changeProcedureProtocolMessageState(protocolId: string, enabled: { Enabled: boolean }, messageId?): Observable<any> {
    
    let url = `${this.appConfig.oc_api_url}${environment.oc_api_procedure_protocols_url}${protocolId}/state`;
    if (messageId)
      url += `?messageId=${messageId}`;
    return this.http.put<any>(url, JSON.stringify(enabled));
  }

  //-----------------------------------------------------------
  // create - ProcedureProtocol - begin
  //-----------------------------------------------------------
  createProcedureProtocol(
    cmd: CreateProcedureProtocolCommand
  ): Observable<any> {
    

    if (environment.debug_mode) {
      console.log("createProcedureProtocol: " + JSON.stringify(cmd));
    }

    let url: string = "";

    url =
      this.appConfig.oc_api_url + environment.oc_api_procedure_protocols_url;

    if (environment.debug_mode) {
      console.log("createProcedureProtocol url: " + url);
    }

    return this.http.post<any>(url, JSON.stringify(cmd));
  }
  //-----------------------------------------------------------
  // create - ProcedureProtocol - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // update - ProcedureProtocol - begin
  //-----------------------------------------------------------
  updateProcedureProtocol(
    cmd: UpdateProcedureProtocolCommand
  ): Observable<any> {
    

    if (environment.debug_mode) {
      console.log("updateProcedureProtocol: " + JSON.stringify(cmd));
    }

    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_procedure_protocols_url +
      cmd.Id;

    if (environment.debug_mode) {
      console.log("updateProcedureProtocol url: " + url);
    }

    return this.http.put<any>(url, JSON.stringify(cmd));
  }
  //-----------------------------------------------------------
  // update - ProcedureProtocol - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // update - AftercareSettings - begin
  //-----------------------------------------------------------
  updateAftercareSettings(
    cmd: UpdateAftercareSettingsCommand
  ): Observable<any> {
    

    if (environment.debug_mode) {
      console.log("updateAftercareSettings: " + JSON.stringify(cmd));
    }

    let urlUpdateAftercareSettings: string = "";

    urlUpdateAftercareSettings =
      this.appConfig.oc_api_url +
      environment.oc_api_organizations_url +
      cmd.OrganisationId +
      "/AftercareSettings";

    if (environment.debug_mode) {
      console.log("updateAftercareSettings url: " + urlUpdateAftercareSettings);
    }

    return this.http.put<any>(urlUpdateAftercareSettings, JSON.stringify(cmd));
  }
  //-----------------------------------------------------------
  // update - AftercareSettings - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  //get PatientProcedureNotes - begin
  //-----------------------------------------------------------
  getPatientProcedureNotes(ppdid: string): Observable<any> {
    

    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_appointments_url +
      "patientprocedurenote?patientproceduredayid=" +
      ppdid;

    if (environment.debug_mode) {
      console.log("getPatientProcedureNotes url: " + url);
    }

    return this.http.get(url);
  }
  //-----------------------------------------------------------
  //get PatientProcedureNotes - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // update - PatientProcedureNotes - begin
  //-----------------------------------------------------------
  updatePatientProcedureNotes(
    cmd: UpdatePatientProcedureNotesCommand
  ): Observable<any> {
    

    if (environment.debug_mode) {
      console.log("updatePatientProcedureNotes: " + JSON.stringify(cmd));
    }

    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_appointments_url +
      "patientprocedurenote";

    if (environment.debug_mode) {
      console.log("updatePatientProcedureNotes url: " + url);
    }

    return this.http.post<any>(url, JSON.stringify(cmd));
  }
  //-----------------------------------------------------------
  // update - PatientProcedureNotes - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  //get AftercareSettings - begin
  //-----------------------------------------------------------
  getAftercareSettings(id: string): Observable<any> {
    

    let url: string =
      this.appConfig.oc_api_url +
      environment.oc_api_organizations_url +
      id +
      "/AftercareSettings";

    if (environment.debug_mode) {
      console.log("getAftercareSettings url: " + url);
    }

    return this.http.get(url);
  }
  //-----------------------------------------------------------
  //get AftercareSettings - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  //get AftercareSettingsCases - begin
  //-----------------------------------------------------------
  getAftercareSettingsCases(orgId: string, caseType: number): Observable<any> {
    

    let urlGetAftercareSettingsCases: string = "";

    urlGetAftercareSettingsCases =
      this.appConfig.oc_api_url +
      environment.oc_api_organizations_url +
      orgId +
      "/Cases?caseType=" +
      caseType;

    if (environment.debug_mode) {
      console.log("getAftercareSettingsCases: " + urlGetAftercareSettingsCases);
    }

    return this.http.get(urlGetAftercareSettingsCases);
  }
  //-----------------------------------------------------------
  //get AftercareSettingsCases - end
  //-----------------------------------------------------------


  //-----------------------------------------------------------
  // Create Case - begin
  //-----------------------------------------------------------
  createCase(cmd: CreateAftercareSettingsCaseCommand): Observable<any> {
    

    let urlCreateCase: string = "";
    urlCreateCase =
      this.appConfig.oc_api_url +
      environment.oc_api_organizations_url +
      cmd.OrganisationId +
      "/Cases";

    if (environment.debug_mode) {
      console.log("createCase: " + JSON.stringify(cmd));
      console.log("createCase url: " + urlCreateCase);
    }

    return this.http.post<any>(urlCreateCase, JSON.stringify(cmd));
  }
  //-----------------------------------------------------------
  // Create Case - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // Update Case - begin
  //-----------------------------------------------------------
  updateCase(cmd: UpdateAftercareSettingsCaseCommand): Observable<any> {
    

    let urlUpdateCase: string = "";

    urlUpdateCase =
      this.appConfig.oc_api_url +
      environment.oc_api_organizations_url +
      cmd.OrganisationId +
      "/Cases/" +
      cmd.Id;

    if (environment.debug_mode) {
      console.log("updateCase: " + JSON.stringify(cmd));
      console.log("updateCase url: " + urlUpdateCase);
    }
    return this.http.put<any>(urlUpdateCase, JSON.stringify(cmd));
  }
  //-----------------------------------------------------------
  // Update Case - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // Delete Case - begin
  //-----------------------------------------------------------
  deleteCase(orgId: string, caseId: string): Observable<any> {
    

    let urlDeleteCase: string = "";

    urlDeleteCase =
      this.appConfig.oc_api_url +
      environment.oc_api_organizations_url +
      orgId +
      "/Cases/" +
      caseId;

    if (environment.debug_mode) {
      console.log("deleteCase, caseId: " + caseId);
      console.log("deleteCase url: " + urlDeleteCase);
    }
    return this.http.delete<any>(urlDeleteCase);
  }
  //-----------------------------------------------------------
  // Delete Case - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  //get AftercareSettingsNotifications - begin
  //-----------------------------------------------------------
  getAftercareSettingsNotications(orgId: string): Observable<any> {
    

    let urlGetAftercareSettingsNotifications: string = "";

    urlGetAftercareSettingsNotifications =
      this.appConfig.oc_api_url +
      environment.oc_api_organizations_url +
      orgId +
      "/Notifications";

    if (environment.debug_mode) {
      console.log(
        "getAftercareSettingsNotifications: " +
        urlGetAftercareSettingsNotifications
      );
    }

    return this.http.get(urlGetAftercareSettingsNotifications);
  }
  //-----------------------------------------------------------
  //get AftercareSettingsNotifications - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // Create Notification - begin
  //-----------------------------------------------------------
  createNotification(
    cmd: CreateAftercareSettingsNotificationCommand
  ): Observable<any> {
    

    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_organizations_url +
      cmd.OrganisationId +
      "/Notifications";

    if (environment.debug_mode) {
      console.log("createNotification: " + JSON.stringify(cmd));
      console.log("createNotification url: " + url);
    }

    return this.http.post<any>(url, JSON.stringify(cmd));
  }
  //-----------------------------------------------------------
  // Create Notification - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // Update Notification - begin
  //-----------------------------------------------------------
  updateNotification(
    cmd: UpdateAftercareSettingsNotificationCommand
  ): Observable<any> {
    

    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_organizations_url +
      cmd.OrganisationId +
      "/Notifications/" +
      cmd.Id;

    if (environment.debug_mode) {
      console.log("updateNotification: " + JSON.stringify(cmd));
      console.log("updateNotification url: " + url);
    }

    return this.http.put<any>(url, JSON.stringify(cmd));
  }

  deleteNotification(orgId: string, notificationId: string): Observable<any> {
    let urlDelete: string = "";

    urlDelete =
      this.appConfig.oc_api_url +
      environment.oc_api_organizations_url +
      orgId +
      "/Notifications/" +
      notificationId;

    if (environment.debug_mode) {
      console.log("deleteNotification, NotificationId: " + notificationId);
      console.log("deleteNotification url: " + urlDelete);
    }
    return this.http.delete<any>(urlDelete);
  }
  //-----------------------------------------------------------
  // Update Notification - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  //search ProcedureMapping - begin
  //-----------------------------------------------------------
  /* NOT USED ANYMORE
  searchProcedureMapping(search: string, orgId: string): Observable<any> {

      let url: string = "";

      //As a user, I would like to search InternalIDs, Procedure Protocol Name, or ExternalIDs
      url = this.appConfig.organisations_url + environment.organisations_api_procedure_protocols_mappings_url + "getProcedureProtocolMappings?organisationId=" + orgId;

      if (search != "") {
          url += "&filter=" + search;
      }


      if (environment.debug_mode) {
          console.log("searchProcedureMapping url: " + url);
      }

      return this.http.get(url);

  }
  */
  //-----------------------------------------------------------
  //search ProcedureMapping - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // Update ProcedureMapping - begin
  //-----------------------------------------------------------
  updateProcedureMapping(
    cmd: UpdateProcedureProtocolMappingCommand
  ): Observable<any> {
    

    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_procedure_protocols_url +
      cmd.Id;

    if (environment.debug_mode) {
      console.log("updateProcedureMapping: " + JSON.stringify(cmd));
      console.log("updateProcedureMapping url: " + url);
    }

    return this.http.put<any>(url, JSON.stringify(cmd));
  }
  //-----------------------------------------------------------
  // Update ProcedureMapping - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // Create ProcedureMapping - begin
  //-----------------------------------------------------------
  createProcedureMapping(
    cmd: CreateProcedureProtocolMappingCommand
  ): Observable<any> {
    

    let url: string = "";

    url =
      this.appConfig.oc_api_url + environment.oc_api_procedure_protocols_url;

    if (environment.debug_mode) {
      console.log("createProcedureMapping: " + JSON.stringify(cmd));
      console.log("createProcedureMapping url: " + url);
    }

    return this.http.post<any>(url, JSON.stringify(cmd));
  }
  //-----------------------------------------------------------
  // Create ProcedureMapping - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  //get ProcedureProtocols -  begin
  //-----------------------------------------------------------
  getProcedureProtocols(
    orgId: string,
    filter: string,
    doctorId: string = null
  ): Observable<any> {
    

    let url: string = "";

    url =
      this.appConfig.oc_api_url + environment.oc_api_procedure_protocols_url;

    if (filter != "") {
      url += "?filter=" + filter;
    }

    if (doctorId) {
      url += `?doctorId=${doctorId}`;
    }

    if (environment.debug_mode) {
      console.log("ProcedureProtocols url: " + url);
    }

    return this.http.get(url);
  }

  getAvailableProcedureProtocols(doctorId: string = null): Observable<any> {
    

    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_procedure_protocols_url +
      "available";

    if (doctorId) {
      url += `?doctorId=${doctorId}`;
    }

    return this.http.get(url);
  }
  getManyAvailableProcedureProtocols(doctorIds: string = null): Observable<any> {
    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_procedure_protocols_url +
      "manyAvailable";

    if (doctorIds) {
      url += `?doctorIds=${doctorIds}`;
    }

    return this.http.get(url);
  }
  //-----------------------------------------------------------
  //get ProcedureProtocols - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  //set Doctor on Organisation Roles - begin
  //-----------------------------------------------------------
  setDoctorOrganisationRoles(roles: RoleDTO[]): RoleDTO[] {
    

    //setup IsDoctor flag - begin
    for (var i = 0; i < roles.length; i++) {
      switch (roles[i].Id) {
        case "00000000-0000-0000-0000-000000000005":
          roles[i].IsDoctor = true;
          roles[i].IsSystemRole = true;
          roles[i].Order = 4;
          break;
        case "00000000-0000-0000-0000-000000000007":
          roles[i].IsDoctor = false;
          roles[i].IsSystemRole = true;
          roles[i].Order = 0;
          break;
        case "00000000-0000-0000-0000-000000000003":
          roles[i].IsDoctor = false;
          roles[i].IsSystemRole = true;
          roles[i].Order = 1;
          break;
        case "00000000-0000-0000-0000-000000000004": 
          roles[i].IsDoctor = false;
          roles[i].IsSystemRole = true;
          roles[i].Order = 2;
          break;
        case "00000000-0000-0000-0000-000000000006":
          roles[i].IsDoctor = false;
          roles[i].IsSystemRole = true;
          roles[i].Order = 3;
          break;
        
        default:
          roles[i].IsDoctor = false;
          roles[i].IsSystemRole = false;
          break;
      }
      //setup IsDoctor flag - end
    }
    return roles;
  }
  //-----------------------------------------------------------
  //set Doctor on Organisation Roles - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  //get Organisation Roles - begin
  //-----------------------------------------------------------
  getOrganisationRoles(orgId: string): Observable<any> {
    

    let url: string = "";

    if (environment.debug_mode) {
      console.log("getOrganisationRoles url: " + url);
    }

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_organizations_url +
      orgId +
      "/roles";

    return this.http.get(url);
  }
  //-----------------------------------------------------------
  //get Organisation Roles - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  //get Auth Org Prmission Roles - begin
  //-----------------------------------------------------------
  getAuthOrgPermissionRoles(): Observable<any> {
    

    let url: string = environment.auth_authority + "api/allpermissions";

    if (environment.debug_mode) {
      console.log("getAuthOrgPermissionRoles, url: " + url);
    }

    return this.http.get(url);
  }
  //-----------------------------------------------------------
  //get Auth Org Permission Roles - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // Get Member Status - begin
  //-----------------------------------------------------------
  getMemberStatus(orgId: string, memberId: string): Observable<string> {
    

    this.appConfig = this.appConfigService.getConfig();

    const url: string =
      this.appConfig.oc_api_url +
      environment.oc_api_members_url +
      memberId +
      "/login/status";

    const requestOptions: Object = {
      /* other options here */
      responseType: "text",
    };

    return this.http.get<string>(url, requestOptions);
  }
  //-----------------------------------------------------------
  // Get Member Status - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // Disable Login - begin
  //-----------------------------------------------------------
  disableLogin(orgId: string, memberId: string): Observable<string> {
    return this.toggleLoginStatus(orgId, memberId, "enabled=false");
  }
  //-----------------------------------------------------------
  // Disable Login - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // Enable Login - begin
  //-----------------------------------------------------------
  enableLogin(orgId: string, memberId: string): Observable<string> {
    return this.toggleLoginStatus(orgId, memberId, "enabled=true");
  }
  //-----------------------------------------------------------
  // Enable Login - end
  //-----------------------------------------------------------

  private toggleLoginStatus(orgId: string, memberId: string, args: string) {
    
    this.appConfig = this.appConfigService.getConfig();
    const url: string =
      this.appConfig.oc_api_url +
      environment.oc_api_members_url +
      memberId +
      "/login/enable?" +
      args;
    const requestOptions: Object = {
      /* other options here */
      responseType: "text",
    };
    return this.http.get<string>(url, requestOptions);
  }

  //-----------------------------------------------------------
  // Create Org Role - begin
  //-----------------------------------------------------------
  createOrgRole(cmd: CreateOrgRoleCommand): Observable<any> {
    

    let url: string =
      this.appConfig.oc_api_url +
      environment.oc_api_organizations_url +
      cmd.OrganizationId +
      "/roles";

    if (environment.debug_mode) {
      console.log("createOrgRole, url: " + url);
    }
    return this.http.post<any>(url, JSON.stringify(cmd));
  }
  //-----------------------------------------------------------
  // Create Org Role - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // Update Org Role - begin
  //-----------------------------------------------------------
  updateOrgRole(cmd: UpdateOrgRoleCommand): Observable<any> {
    

    let url: string =
      this.appConfig.oc_api_url +
      environment.oc_api_organizations_url +
      cmd.OrganizationId +
      "/roles/" +
      cmd.Id;

    if (environment.debug_mode) {
      console.log("updateOrgRole, url: " + url);
    }
    return this.http.put<any>(url, JSON.stringify(cmd));
  }
  //-----------------------------------------------------------
  // Update Auth Org Role - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // Search Org Centers - begin
  //-----------------------------------------------------------
  searchOrgCenters(
    orgId: string,
    name: string,
    selectedGroups: string[],
    activation: number,
    page: number,
    limit: number
  ): Observable<any> {
    

    let url: string =
      this.appConfig.oc_api_url +
      environment.oc_api_centers_url +
      "?filter=" +
      name +
      "&groups=" +
      selectedGroups +
      "&activation=" +
      activation +
      "&CurrentPage=" +
      page +
      "&PageLimit=" +
      limit;

    if (environment.debug_mode) {
      console.log("searchOrgCenters url: " + url);
    }

    return this.http.get(url);
  }
  //-----------------------------------------------------------
  // Search Org Centers - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // Search Org Members - begin
  //-----------------------------------------------------------
  searchOrgMembers(
    orgID: string,
    search: string,
    selectedMemberCenters: OrganisationCenterDTO[],
    selectedMemberRoles: RoleDTO[],
    activated: number,
    page: number,
    limit: number
  ): Observable<any> {
    

    let tmpRoles: string[] = [];

    if (selectedMemberRoles.length > 0) {
      selectedMemberRoles
        .filter((x) => typeof (x) !== undefined)
        .forEach(function (value) {
          tmpRoles.push(value.Id);
        });
    }

    let tmpCenters: string[] = [];
    if (selectedMemberCenters.length > 0) {
      selectedMemberCenters
        .filter((x) => typeof (x) !== undefined)
        .forEach(function (value) {
          tmpCenters.push(value.Id);
        });
    }

    if (environment.debug_mode) {
      console.log("searchOrgMembers - selectedRoles: " + tmpRoles);
      console.log("searchOrgMembers - selectedCenters: " + tmpCenters);
      console.log("searchOrgMembers - selectedInput: " + search);
    }

    let url: string =
      this.appConfig.oc_api_url +
      environment.oc_api_members_url +
      "?filter=" +
      search +
      "&CurrPage=" +
      page +
      "&PageLimit=" +
      limit +
      "&centers=" +
      tmpCenters +
      "&roles=" +
      tmpRoles +
      "&activated=" +
      (activated == -1 ? "" : activated == 1);

    if (environment.debug_mode) {
      console.log("searchOrgMembers url: " + url);
    }

    return this.http.get(url);
  }
  //-----------------------------------------------------------
  // Search Org Members - end
  //-----------------------------------------------------------

  //----------------------------------------------------------
  // Get Member - begin
  //----------------------------------------------------------
  private _member: Observable<any>;
  private _memberLastUrl: string;
  getOrganisationMember(
    memberId: string,
    userId: string = ""
  ): Observable<any> {
    

    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_members_url +
      "member?memberId=" +
      memberId +
      "&memberUserId=" +
      userId;

    if (!this._member || url !== this._memberLastUrl) {
      this._memberLastUrl = url;

      if (environment.debug_mode) {
        console.log("getOrganisationMember: " + url);
      }

      this._member = this.http.get(url).pipe(
        map((data) => data),
        publishReplay(1),
        refCount()
      );
    }

    return this._member;
  }

  checkMemberExists(externalId: string): Observable<boolean> {
    

    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_members_url +
      "exist?filter=" +
      externalId;

    if (!this._member || url !== this._memberLastUrl) {
      this._memberLastUrl = url;

      if (environment.debug_mode) {
        console.log("getOrganisationMember: " + url);
      }

      return this.http.get<boolean>(url).pipe(
        map((data) => data),
        publishReplay(1),
        refCount()
      );
    }
    return of(false);
  }

  clearMember() {
    this._member = null;
  }
  //----------------------------------------------------------
  // Get Member - end
  //----------------------------------------------------------

  //----------------------------------------------------------
  // Get MemberRoles - begin
  //----------------------------------------------------------
  getOrganisationMemberRoles(orgId: string, memberId: string): Observable<any> {
    

    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_members_url +
      "memberroles?MemberId=" +
      memberId;

    if (environment.debug_mode) {
      console.log("getOrganisationMemberRoles: " + url);
    }

    return this.http.get(url);
  }

  //----------------------------------------------------------
  // Get MemberRoles - end
  //----------------------------------------------------------

  //----------------------------------------------------------
  // Get MemberAftercareSettings - begin
  //----------------------------------------------------------
  getMemberAftercareSettings(memberId: string): Observable<any> {
    

    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_members_url +
      "aftercaresettings?MemberId=" +
      memberId;

    if (environment.debug_mode) {
      console.log("getMemberAftercareSettings: " + url);
    }

    return this.http.get(url);
  }

  //----------------------------------------------------------
  // Get MemberAftercareSettings - end
  //----------------------------------------------------------

  //-----------------------------------------------------------
  // update - OrganisationMember - begin
  //-----------------------------------------------------------
  updateOrganisationMember(
    cmd: UpdateOrganisationMemberCommand
  ): Observable<any> {
    

    let url: string = "";

    url = this.appConfig.oc_api_url + environment.oc_api_members_url;

    if (environment.debug_mode) {
      console.log("updateOrganisationMember: " + JSON.stringify(cmd));
      console.log("updateOrganisationMember url: " + url);
    }

    return this.http.put<any>(url, JSON.stringify(cmd));
  }
  //-----------------------------------------------------------
  // update - OrganisationMember - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // create - OrganisationMember - begin
  //-----------------------------------------------------------
  createOrganisationMember(
    cmd: CreateOrganisationMemberCommand
  ): Observable<any> {
    

    let url: string = "";

    url = this.appConfig.oc_api_url + environment.oc_api_members_url;

    if (environment.debug_mode) {
      console.log("createOrganisationMember: " + JSON.stringify(cmd));
      console.log("createOrganisationMember url: " + url);
    }

    return this.http.post<any>(url, JSON.stringify(cmd));
  }
  //-----------------------------------------------------------
  // create - OrganisationMember - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // create - MemberAftercareSettings - begin
  //-----------------------------------------------------------
  createMemberAftercareSetting(
    cmd: CreateMemberAftercareSettingCommand
  ): Observable<any> {
    

    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_members_url +
      "aftercaresettings";

    if (environment.debug_mode) {
      console.log("createMemberAftercareSetting: " + JSON.stringify(cmd));
      console.log("createMemberAftercareSetting url: " + url);
    }

    return this.http.post<any>(url, JSON.stringify(cmd));
  }
  //-----------------------------------------------------------
  // create - MemberAftercareSettings - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // update - MemberAftercareSettings - begin
  //-----------------------------------------------------------
  updateMemberAftercareSetting(
    cmd: UpdateMemberAftercareSettingCommand
  ): Observable<any> {
    

    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_members_url +
      "aftercaresettings";

    if (environment.debug_mode) {
      console.log("updateMemberAftercareSetting: " + JSON.stringify(cmd));
      console.log("updateMemberAftercareSetting url: " + url);
    }

    return this.http.put<any>(url, JSON.stringify(cmd));
  }
  //-----------------------------------------------------------
  // update - MemberAftercareSettings - end
  //-----------------------------------------------------------

  //----------------------------------------------------------
  // Get DoctorProviderMappings - begin
  //----------------------------------------------------------
  getDoctorProviderMappings(orgId: string, memberId: string): Observable<any> {
    

    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_members_url +
      "doctorprovidermapping?MemberId=" +
      memberId;

    if (environment.debug_mode) {
      console.log("getDoctorProviderMappings: " + url);
    }

    return this.http.get(url);
  }

  //----------------------------------------------------------
  // Get DoctorProviderMappings - end
  //----------------------------------------------------------

  //-----------------------------------------------------------
  // create - DoctorProviderMappings - begin
  //-----------------------------------------------------------
  createDoctorProviderMappings(
    cmd: CreateDoctorProviderMappingCommand
  ): Observable<any> {
    

    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_members_url +
      "doctorprovidermapping";

    if (environment.debug_mode) {
      console.log("createDoctorProviderMappings: " + JSON.stringify(cmd));
      console.log("createDoctorProviderMappings url: " + url);
    }

    return this.http.post<any>(url, JSON.stringify(cmd));
  }
  //-----------------------------------------------------------
  // create - DoctorProviderMappings - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // update - DoctorProviderMappings - begin
  //-----------------------------------------------------------
  updateDoctorProviderMappings(
    cmd: UpdateDoctorProviderMappingCommand
  ): Observable<any> {
    

    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_members_url +
      "doctorprovidermapping";

    if (environment.debug_mode) {
      console.log("updateDoctorProviderMappings: " + JSON.stringify(cmd));
      console.log("updateDoctorProviderMappings url: " + url);
    }

    return this.http.put<any>(url, JSON.stringify(cmd));
  }
  //-----------------------------------------------------------
  // update - DoctorProviderMappings - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  //get Organisation - begin
  //-----------------------------------------------------------
  _organization: Observable<any>;

  getOrganisation(id: string): Observable<any> {
    

    if (!this._organization) {
      let url: string =
        this.appConfig.oc_api_url + environment.oc_api_organizations_url + id;

      if (environment.debug_mode) {
        console.log("getOrganisation: " + url);
      }

      this._organization = this.http.get(url).pipe(
        map((data) => data),
        publishReplay(1),
        refCount()
      );
    }

    return this._organization;
  }

  clearOrganization() {
    this._organization = null;
  }
  //-----------------------------------------------------------
  //get Organisation - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  //get OrganisationCenterAftercareSettings - begin
  //-----------------------------------------------------------
  getOrganisationCenterAftercareSettings(
    orgId: string,
    centerId: string
  ): Observable<any> {
    

    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_centers_url +
      centerId +
      "/AftercareSettings";

    if (environment.debug_mode) {
      console.log("getOrganisationCenterAftercareSettings: url: " + url);
    }

    return this.http.get(url);
  }

  getAvailableDomains(
  ): Observable<any> {
    

    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_available_domains_url;

    return this.http.get(url);
  }
  //-----------------------------------------------------------
  //get OrganisationCenterAftercareSettings - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // update - OrganisationCenterAftercareSettings - begin
  //-----------------------------------------------------------
  updateOrganisationCenterAftercareSettings(
    cmd: UpdateOrganisationCenterAftercareSettingsCommand
  ): Observable<any> {
    

    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_centers_url +
      cmd.CenterId +
      "/AftercareSettings";

    if (environment.debug_mode) {
      console.log(
        "updateOrganisationCenterAftercareSettings: " + JSON.stringify(cmd)
      );
      console.log("updateOrganisationCenterAftercareSettings url: " + url);
    }

    return this.http.put<any>(url, JSON.stringify(cmd));
  }
  //-----------------------------------------------------------
  // update - OrganisationCenterAftercareSettings - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // create - OrganisationCenterAftercareSettings - begin
  //-----------------------------------------------------------
  //NOT USED ANYMORE!!!
  createOrganisationCenterAftercareSettings(
    cmd: CreateOrganisationCenterAftercareSettingsCommand
  ): Observable<any> {
    

    let url: string = "";

    url = "NOT USED AMYMORE!!!"; //this.appConfig.organisations_url + environment.organisations_api_organisations_centers_url + "createAftercareSettings";

    if (environment.debug_mode) {
      console.log(
        "createOrganisationCenterAftercareSettings: " + JSON.stringify(cmd)
      );
      console.log("createOrganisationCenterAftercareSettings url: " + url);
    }

    return this.http.post<any>(url, JSON.stringify(cmd));
  }
  //-----------------------------------------------------------
  // create - OrganisationCenterAftercareSettings - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // update - Organisation - begin
  //-----------------------------------------------------------
  updateOrganisation(
    id: string,
    cmd: UpdateOrganisationCommand
  ): Observable<any> {
    

    let url: string =
      this.appConfig.oc_api_url + environment.oc_api_organizations_url + cmd.Id;

    if (environment.debug_mode) {
      console.log("updateOrganisation: " + JSON.stringify(cmd));
      console.log("updateOrganisation url: " + url);
    }

    return this.http.put<any>(url, JSON.stringify(cmd));
  }
  //-----------------------------------------------------------
  // update - Organisation - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // update - OrganisationMemberRole - begin
  //-----------------------------------------------------------
  //https://localhost:8001/api/OrganisationMemberRoles/updateMemberRole
  updateOrganisationMemberRole(
    cmd: UpdateOrganisationMemberRoleCommand[]
  ): Observable<any> {
    

    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_members_url +
      "memberroles";

    if (environment.debug_mode) {
      console.log("updateOrganisationMemberRole: " + JSON.stringify(cmd));
      console.log("updateOrganisationMemberRole url: " + url);
    }

    return this.http.put<any>(url, JSON.stringify(cmd));
  }
  //-----------------------------------------------------------
  // update - OrganisationMemberRole - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // create - OrganisationMemberRole - begin
  //-----------------------------------------------------------
  createOrganisationMemberRole(
    cmd: CreateOrganisationMemberRoleCommand
  ): Observable<any> {
    

    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_members_url +
      "memberroles";

    if (environment.debug_mode) {
      console.log("createOrganisationMemberRole: " + JSON.stringify(cmd));
      console.log("createOrganisationMemberRole url: " + url);
    }

    return this.http.post<any>(url, JSON.stringify(cmd));
  }
  //-----------------------------------------------------------
  // create - OrganisationMemberRole - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // update - OrganisationCenter - begin
  //-----------------------------------------------------------
  updateOrganisationCenter(
    cmd: UpdateOrganisationCenterCommand
  ): Observable<any> {
    

    let url: string = "";

    url = this.appConfig.oc_api_url + environment.oc_api_centers_url + cmd.Id;

    if (environment.debug_mode) {
      console.log("updateOrganisationCenter: " + JSON.stringify(cmd));
      console.log("updateOrganisationCenter url: " + url);
    }

    return this.http.put<any>(url, JSON.stringify(cmd));
  }
  //-----------------------------------------------------------
  // update - OrganisationCenter - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // create - OrganisationCenter - begin
  //-----------------------------------------------------------
  createOrganisationCenter(
    cmd: CreateOrganisationCenterCommand
  ): Observable<any> {
    

    let url: string = "";

    url = this.appConfig.oc_api_url + environment.oc_api_centers_url;

    if (environment.debug_mode) {
      console.log("createOrganisationCenter: " + JSON.stringify(cmd));
      console.log("createOrganisationCenter url: " + url);
    }

    return this.http.post<any>(url, JSON.stringify(cmd));
  }
  //-----------------------------------------------------------
  // create - OrganisationCenter - end
  //-----------------------------------------------------------

  changeMemberLanguage(userId: string, language: string) {
    

    let url: string = "";

    url =
      this.appConfig.oc_api_url +
      environment.oc_api_members_url +
      userId +
      "/language";

    if (environment.debug_mode) {
      console.log("changeMemberLanguage: " + url);
    }

    return this.http.put(url, '"' + language + '"');
  }

  getDoctorItems(centerId: string[] = null): Observable<any> {
    

    let url: string = "";
    url =
      this.appConfig.oc_api_url +
      environment.oc_api_members_url +
      "doctors/items";

    if (centerId) url += `?centerId=${centerId}`;

    return this.http.post(url,centerId);
  }

  deactivateCenter(selectedCenterID: string): Observable<any> {
    

    let url: string = "";
    url =
      this.appConfig.oc_api_url +
      environment.oc_api_centers_url +
      selectedCenterID +
      "/deactivate";

    return this.http.put(url, "");
  }

  activateCenter(selectedCenterID: string): Observable<any> {
    

    let url: string = "";
    url =
      this.appConfig.oc_api_url +
      environment.oc_api_centers_url +
      selectedCenterID +
      "/activate";

    return this.http.put(url, "");
  }
  
  centerCommseEnable(selectedCenterID: string): Observable<any> {
    

    let url: string = "";
    url =
      this.appConfig.oc_api_url +
      environment.oc_api_centers_url +
      selectedCenterID +
      "/commsEnable";

    return this.http.put(url, "");
  }
  
  centerCommseDisable(selectedCenterID: string): Observable<any> {
    

    let url: string = "";
    url =
      this.appConfig.oc_api_url +
      environment.oc_api_centers_url +
      selectedCenterID +
      "/commsDisable";

    return this.http.put(url, "");
  }

  getTopLevelStatSettings(): Observable<any> {
    

    let url: string = "";
    url =
      this.appConfig.reports_api_url +
      environment.reports_api_settings_url +
      "toplevelstats";

    return this.http.get(url);
  }

  updateTopLevelStatSettings(
    topLevelStatSettings: TopLevelStatSetting[]
  ): Observable<any> {
    

    let url: string = "";
    url =
      this.appConfig.reports_api_url +
      environment.reports_api_settings_url +
      "toplevelstats";

    return this.http.put(url, topLevelStatSettings);
  }

  getUnresolvedAlertsSettings(): Observable<any> {
    

    let url: string = "";
    url =
      this.appConfig.reports_api_url +
      environment.reports_api_settings_url +
      "unresolvedalerts";

    return this.http.get(url);
  }

  updateUnresolvedAlertsSettings(
    topLevelStatSettings: UnresolvedAlertsSettingsDto
  ): Observable<any> {
    

    let url: string = "";
    url =
      this.appConfig.reports_api_url +
      environment.reports_api_settings_url +
      "unresolvedalerts";

    return this.http.put(url, topLevelStatSettings);
  }

  getAlertResolutionTimeSettings(): Observable<any> {
    

    let url: string = "";
    url =
      this.appConfig.reports_api_url +
      environment.reports_api_settings_url +
      "alertresolutiontime";

    return this.http.get(url);
  }

  updateAlertResolutionTimeSettings(
    topLevelStatSettings: AlertResolutionTimeSettingsDto
  ): Observable<any> {
    

    let url: string = "";
    url =
      this.appConfig.reports_api_url +
      environment.reports_api_settings_url +
      "alertresolutiontime";

    return this.http.put(url, topLevelStatSettings);
  }

  createLogin(memberId: string): Observable<any> {
    

    const url: string =
      this.appConfig.oc_api_url +
      environment.oc_api_members_url +
      memberId +
      "/create-login";

    return this.http.get(url);
  }

  reActivation(memberId: string, activate: boolean): Observable<any> {
    

    const url: string =
      this.appConfig.oc_api_url +
      environment.oc_api_members_url +
      memberId +
      "/re-activation/" +
      activate;

    return this.http.get(url);
  }

  getGroupCategories(orgId: string): Observable<any> {
    

    const url: string =
      this.appConfig.oc_api_url +
      environment.oc_api_organizations_url +
      orgId +
      "/group-categories";

    return this.http.get(url);
  }

  setOrgGroupCategories(
    orgId: string,
    organizationGroups: GroupCategoryDTO[]
  ): Observable<any> {
    

    const url: string =
      this.appConfig.oc_api_url +
      environment.oc_api_organizations_url +
      orgId +
      "/group-categories";

    return this.http.put(url, organizationGroups);
  }

  getResponseRateGraphSettings(): Observable<any> {
    

    let url: string = "";
    url =
      this.appConfig.reports_api_url +
      environment.reports_api_settings_url +
      "responserate";

    return this.http.get(url);
  }

  getResponseRateGraph2Settings(): Observable<any> {
    

    let url: string = "";
    url =
      this.appConfig.reports_api_url +
      environment.reports_api_settings_url +
      "responserate2";

    return this.http.get(url);
  }

  getResponseRateGraph3Settings(): Observable<any> {
    

    let url: string = "";
    url =
      this.appConfig.reports_api_url +
      environment.reports_api_settings_url +
      "responserate3";

    return this.http.get(url);
  }

  updateResponserRateGraphSettings(
    settings: ResponseRateGraphSettingsDto
  ): Observable<any> {
    

    let url: string = "";
    url =
      this.appConfig.reports_api_url +
      environment.reports_api_settings_url +
      "responserate";

    return this.http.put(url, settings);
  }

  updateResponserRateGraph2Settings(
    settings: ResponseRateGraphSettingsDto
  ): Observable<any> {
    

    let url: string = "";
    url =
      this.appConfig.reports_api_url +
      environment.reports_api_settings_url +
      "responserate2";

    return this.http.put(url, settings);
  }

  updateResponserRateGraph3Settings(
    settings: ResponseRateGraphSettingsDto
  ): Observable<any> {
    

    let url: string = "";
    url =
      this.appConfig.reports_api_url +
      environment.reports_api_settings_url +
      "responserate3";

    return this.http.put(url, settings);
  }

  getNpsGraphSettings(): Observable<any> {
    

    let url: string = "";
    url =
      this.appConfig.reports_api_url +
      environment.reports_api_settings_url +
      "npsgraph";

    return this.http.get(url);
  }

  getNpsGraph2Settings(): Observable<any> {
    

    let url: string = "";
    url =
      this.appConfig.reports_api_url +
      environment.reports_api_settings_url +
      "npsgraph2";

    return this.http.get(url);
  }

  updateNpsGraphSettings(settings: NpsGraphSettingsDto): Observable<any> {
    

    let url: string = "";
    url =
      this.appConfig.reports_api_url +
      environment.reports_api_settings_url +
      "npsgraph";

    return this.http.put(url, settings);
  }

  updateNpsGraph2Settings(settings: NpsGraphSettingsDto): Observable<any> {
    

    let url: string = "";
    url =
      this.appConfig.reports_api_url +
      environment.reports_api_settings_url +
      "npsgraph2";

    return this.http.put(url, settings);
  }

  getCustomGraph1Settings(): Observable<any> {
    

    let url: string = "";
    url =
      this.appConfig.reports_api_url +
      environment.reports_api_settings_url +
      "customgraph1";

    return this.http.get(url);
  }

  updateCustomGraph1Settings(
    settings: CustomGraphSettingsDto
  ): Observable<any> {
    

    let url: string = "";
    url =
      this.appConfig.reports_api_url +
      environment.reports_api_settings_url +
      "customgraph1";

    return this.http.put(url, settings);
  }

  getCustomGraph2Settings(): Observable<any> {
    

    let url: string = "";
    url =
      this.appConfig.reports_api_url +
      environment.reports_api_settings_url +
      "customgraph2";

    return this.http.get(url);
  }

  updateCustomGraph2Settings(
    settings: CustomGraphSettingsDto
  ): Observable<any> {
    

    let url: string = "";
    url =
      this.appConfig.reports_api_url +
      environment.reports_api_settings_url +
      "customgraph2";

    return this.http.put(url, settings);
  }

  getMultipleChoiceGraph(): Observable<any> {
    

    let url: string = "";
    url =
      this.appConfig.reports_api_url +
      environment.reports_api_settings_url +
      "multiplechoice";

    return this.http.get(url);
  }

  updateMultipleChoiceGraph(
    settings: MultipleChoiceGraphSettingsDto
  ): Observable<any> {
    

    let url: string = "";
    url =
      this.appConfig.reports_api_url +
      environment.reports_api_settings_url +
      "multiplechoice";

    return this.http.put(url, settings);
  }

  getTrendingWords(): Observable<any> {
    

    let url: string = `${this.appConfig.reports_api_url}${environment.reports_api_settings_url}trendingwords`;

    return this.http.get(url);
  }

  getCommentsDisplay(): Observable<CommentsDisplaySettingsDto> {
    

    let url: string = `${this.appConfig.reports_api_url}${environment.reports_api_settings_url}patientcomments`;

    return this.http.get<CommentsDisplaySettingsDto>(url);
  }

  getResponseAnalysis(): Observable<ResponseAnalysisSettingsDto> {
    

    let url: string = `${this.appConfig.reports_api_url}${environment.reports_api_settings_url}responseanalysis`;

    return this.http.get<ResponseAnalysisSettingsDto>(url);
  }

  getGoogleReviewsGraph(): Observable<GoogleReviewsGraphSettingsDto> {
    

    let url: string = `${this.appConfig.reports_api_url}${environment.reports_api_settings_url}googlereviews`;

    return this.http.get<GoogleReviewsGraphSettingsDto>(url);
  }

  getOnlineBookingGraph(): Observable<OnlineBookingGraphSettingsDto> {
    
    let url: string = `${this.appConfig.reports_api_url}${environment.reports_api_settings_url}onlinebooking`;

    return this.http.get<OnlineBookingGraphSettingsDto>(url);
  }

  updateTrendingWords(settings: TrendingWordsSettingsDto): Observable<any> {
    

    let url: string = `${this.appConfig.reports_api_url}${environment.reports_api_settings_url}trendingwords`;

    return this.http.put(url, settings);
  }

  updateCommentsDisplay(settings: CommentsDisplaySettingsDto): Observable<any> {
    

    let url: string = `${this.appConfig.reports_api_url}${environment.reports_api_settings_url}patientcomments`;

    return this.http.put(url, settings);
  }

  updateResponseAnalysis(settings: ResponseAnalysisSettingsDto): Observable<any> {
    

    let url: string = `${this.appConfig.reports_api_url}${environment.reports_api_settings_url}responseanalysis`;

    return this.http.put(url, settings);
  }

  updateGoogleReviews(settings: GoogleReviewsGraphSettingsDto): Observable<any> {
    

    let url: string = `${this.appConfig.reports_api_url}${environment.reports_api_settings_url}googlereviews`;

    return this.http.put(url, settings);
  }

  updateOnlineBooking(settings: OnlineBookingGraphSettingsDto): Observable<any> {
    

    let url: string = `${this.appConfig.reports_api_url}${environment.reports_api_settings_url}onlinebooking`;

    return this.http.put(url, settings);
  }

  triggerwidgetUpdate(widgetEndpoint: string): Observable<any> {
    
    let url: string = `${this.appConfig.reports_migration_url}${environment.reports_api_data_migrations_url}${widgetEndpoint}`;

    return this.http.get(url);
  }

  getDashboardInfo(): Observable<any> {
    

    let url: string = "";
    url =
      this.appConfig.reports_api_url +
      environment.reports_api_dashboard_url +
      "info";

    return this.http.get(url);
  }

  getAlertsTopLevelStats(): Observable<TopLevelStatSetting[]> {
    

    let url: string = "";
    url =
      this.appConfig.reports_api_url +
      environment.reports_api_dashboard_url +
      "alerts/info";

    return this.http.get<TopLevelStatSetting[]>(url);
  }

  getSubscriptionItems(): Observable<any> {
    

    let url: string = "";
    url = this.appConfig.oc_api_url + environment.oc_api_org_subscriptions;

    return this.http.get(url);
  }

  getProductInfo(): Observable<any> {
    
    const url = this.appConfig.oc_api_url + environment.oc_api_org_product;
    return this.http.get(url);
  }

  getSuggestedReplies(): Observable<SuggestedReplyDto[]> {
    

    let url: string = `${this.appConfig.oc_api_url}${environment.oc_api_organizations_url}suggested-replies`;

    return this.http.get<SuggestedReplyDto[]>(url);
  }

  updateSuggestedReplies(settings: SuggestedReplyDto[]): Observable<any> {
    

    let url: string = `${this.appConfig.oc_api_url}${environment.oc_api_organizations_url}suggested-replies`;

    return this.http.put(url, settings);
  }

  addSuggestedReplyClick(data: any): Observable<any> {
    

    let url: string = `${this.appConfig.oc_api_url}${environment.oc_api_organizations_url}suggested-replies/click`;

    return this.http.post(url, data);
  }

  getAutoReportsSettings(): Observable<AutoReportsSettingsDto> {
    

    let url: string = `${this.appConfig.reports_api_url}${environment.reports_api_settings_url}autoreports`;

    return this.http.get<AutoReportsSettingsDto>(url);
  }

  updateAutoReportsSettings(data: AutoReportsSettingsDto): Observable<any> {
    

    let url: string = `${this.appConfig.reports_api_url}${environment.reports_api_settings_url}autoreports`;

    return this.http.put(url, data);
  }

  postReQueueComms(){
    let url: string = this.appConfig.oc_api_url +
    environment.oc_api_appointments_url + 're-queue-communications' 

    return this.http.post(url,null);
  }
  postCancelAllComms(){
    let url: string = this.appConfig.oc_api_url +
    environment.oc_api_appointments_url + 'cancel-communications' 

    return this.http.post(url,null);
  }

  checkPassiveMode(orgId: string): Observable<boolean>
   {
      const url: string =
        this.appConfig.oc_api_url +environment.oc_api_organization_import_settings_url+orgId+
        environment.oc_passive_mode_url;
      if (environment.debug_mode) {
        console.log("checkPassiveMode url: " + url);
      }
       this._isPassiveMode = this.http.get<boolean>(url).pipe(
         publishReplay(1),
         refCount()
       );
      //this._isPassiveMode= of(true);
  
    return this._isPassiveMode;
  }

  saveExcludedQuestionAnswers(excludeQuestionAnswersDTOList:ExcludeQuestionAnswersDTO[]): Observable<any> {
    
    let url: string = `${this.appConfig.reports_api_url}${environment.reports_api_settings_url}excludedquestionanswers`;
    return this.http.put(url,excludeQuestionAnswersDTOList);
  }

  removeExcludedQuestionAnswers(excludeQuestionAnswersDTOList:ExcludeQuestionAnswersDTO[]): Observable<any> {
    let options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(excludeQuestionAnswersDTOList)
    };
    let url: string = `${this.appConfig.reports_api_url}${environment.reports_api_settings_url}excludedquestionanswers`;
    return this.http.delete(url,options);
  }

  getExcludedQuestionAnswers(centerId:string): Observable<any> {
    let url: string =`${this.appConfig.reports_api_url}${environment.reports_api_settings_url}excludedquestionanswers?centerId=${centerId}`;
    return this.http.get(url);
}
}